export default [
  {
    path: "/exhibition", //展会页面
    name: "Exhibition",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/exhibition"),
  },
  {
    path: "/exhibitionProductDetail", //展会商品详情页
    name: "ExhibitionProductDetail",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/exhibition/productDetail"),
  },
  {
    path: "/exhibitionShop", //展会店铺页
    name: "ExhibitionShop",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/exhibition/shop"),
  },
  {
    path: "/exhibitionSearch", //展会搜索页
    name: "ExhibitionSearch",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/exhibition/search"),
  },
  // ==================== 秒杀系统路由 ====================
  {
    path: "/seckill/register", //秒杀注册/签到
    name: "SeckillRegister",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/seckill/register"),
  },
  {
    path: "/seckill/order/:productId", //抢购页面
    name: "SeckillOrder",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/seckill/order"),
  },
  {
    path: "/seckill/cart", //订单汇总/购物车
    name: "SeckillCart",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/seckill/cart"),
  },
  {
    path: "/seckill/screen", //大屏展示页
    name: "SeckillScreen",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/seckill/liveScreen"),
  },
  {
    path: "/seckill/live-screen", //订货会秒杀大屏
    name: "SeckillLiveScreen",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/seckill/liveScreen"),
  },
  {
    path: "/seckill/admin", //后台管理
    name: "SeckillAdmin",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/seckill/admin"),
  },
  {
    path: "/seckill/lottery", //抽奖页面
    name: "SeckillLottery",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/seckill/lottery"),
  },
  {
    path: "/seckill/console", //大屏控制面板
    name: "SeckillConsole",
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: false,
    },
    component: () => import("@pages/seckill/console"),
  },
];
